import { render, staticRenderFns } from "./BrainExercise.vue?vue&type=template&id=a53b988e"
import script from "./BrainExercise.vue?vue&type=script&lang=js"
export * from "./BrainExercise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports